const columns = (renderCell, renderJsonField) => [
  {
    field: 'userEmail',
    headerName: 'Email ID',
    width: 300,
    hide: false,
    renderCell,
    headerAlign: 'center',
    align: 'center',
    valueGetter: params => params.row.details?.userEmail
  },
  {
    field: 'ip',
    headerName: 'IP',
    width: 350,
    renderCell,
    headerAlign: 'center',
    align: 'center',
    valueGetter: params => params.row.details.payload.user?.ip,
    hide: true
  },
  {
    field: 'lastUpdate',
    headerName: 'Timestamp',
    width: 250,
    hide: false,
    renderCell,
    headerAlign: 'center'
  },
  {
    field: 'routeName',
    headerName: 'Route',
    width: 350,
    renderCell,
    headerAlign: 'center',
    align: 'center',
    valueGetter: params => params.row.details.caller?.usage
  },
  {
    field: 'routeEndpoint',
    headerName: 'Route Endpoint',
    width: 350,
    renderCell,
    headerAlign: 'center',
    align: 'center',
    valueGetter: params => params.row.details.caller?.route,
    hide: true
  },
  {
    field: 'well',
    headerName: 'Well',
    width: 250,
    renderCell,
    headerAlign: 'center',
    align: 'center',
    valueGetter: params => params.row.details.wellsInfo?.name
  },
  {
    field: 'rig',
    headerName: 'Rig',
    width: 250,
    renderCell,
    headerAlign: 'center',
    align: 'center',
    valueGetter: params => params.row.details.wellsInfo?.rig
  },
  {
    field: 'details',
    headerName: 'Details',
    width: 300,
    renderCell: renderJsonField,
    headerAlign: 'center',
    align: 'center',
    sortable: false
  }
];

export default columns;
